export const SHIPPING_RATES = {
  Chile: {
    express: {
      cod: 2400,
      fee: 3500,
    },
    numberFormat: {
      code: 'es-CL',
      currency: 'CLP',
    },
    overnight: {
      cod: 2000,
      fee: 3200,
    },
    sameday: {
      cod: 2200,
      fee: 3800,
    },
    standard: {
      cod: 1950,
      fee: 2900,
    },
  },
  Colombia: {
    express: {
      cod: 9600,
      fee: 14000,
    },
    numberFormat: {
      code: 'es-CO',
      currency: 'COP',
    },
    overnight: {
      cod: 8000,
      fee: 12800,
    },
    sameday: {
      cod: 8900,
      fee: 15200,
    },
    standard: {
      cod: 7800,
      fee: 11600,
    },
  },
  Peru: {
    express: {
      cod: 9,
      fee: 13,
    },
    numberFormat: {
      code: 'es-PE',
      currency: 'PEN',
    },
    overnight: {
      cod: 8,
      fee: 12,
    },
    sameday: {
      cod: 10,
      fee: 14,
    },
    standard: {
      cod: 7,
      fee: 11,
    },
  },
};
